/** Pull a parameter value from HireBroker property.parameters array */
export const findParameter = (parameters, name) => {
  if (!Array.isArray(parameters)) return null;
  const param = parameters.find(
    (p) => String(p?.name || '').toLowerCase() === String(name).toLowerCase()
  );
  return param?.value ?? null;
};

/** Normalize property objects from favourites, saved, or recently viewed APIs */
export const normalizeProperty = (raw) => {
  if (!raw) return null;
  const p = raw.property || raw;
  const id = p.id ?? raw.property_id ?? raw.id;
  if (!id) return null;

  const bedrooms =
    p.bedrooms ?? findParameter(p.parameters, 'bedrooms') ?? findParameter(p.parameters, 'Bedroom');
  const bathrooms =
    p.bathrooms ?? findParameter(p.parameters, 'bathrooms') ?? findParameter(p.parameters, 'Bathroom');
  const area =
    p.sqft ??
    p.area ??
    findParameter(p.parameters, 'area') ??
    findParameter(p.parameters, 'sqft') ??
    findParameter(p.parameters, 'Plot Area');

  const image =
    p.title_image ||
    (Array.isArray(p.images) ? p.images[0]?.image_url || p.images[0] : null) ||
    p.image ||
    '';

  const location =
    [p.city, p.state, p.address].filter(Boolean).join(', ') ||
    p.location ||
    p.address ||
    p.city ||
    '—';

  return {
    id,
    slug_id: p.slug_id,
    title: p.title || 'Untitled property',
    price: p.price != null ? Number(p.price) : null,
    image,
    location,
    city: p.city || '',
    bedrooms: bedrooms != null && bedrooms !== '' ? bedrooms : null,
    bathrooms: bathrooms != null && bathrooms !== '' ? bathrooms : null,
    area: area != null && area !== '' ? area : null,
    property_type: p.propery_type ?? p.property_type,
    category: p.category?.category || p.category_name || '',
    isFavorite: true,
    viewedDate: raw.viewed_date || raw.viewedDate || null,
    savedDate: raw.saved_date || raw.savedDate || null,
    raw: p,
  };
};

/** @deprecated Prefer useCurrency().formatPrice — kept for non-React helpers */
export const formatPrice = (price) => {
  if (price == null || Number.isNaN(Number(price))) return 'Price on request';
  return `UGX ${Number(price).toLocaleString()}`;
};

export const formatRelativeDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  const diffMs = Date.now() - date.getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return 'Just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  return date.toLocaleDateString();
};

export const propertyHref = (property) => {
  if (property?.slug_id) return `/property/${property.slug_id}`;
  if (property?.id) return `/property/${property.id}`;
  return '/property-search-browse';
};
